import db from 'src/lib/dexie-db/db';
import { SyncStatus } from 'src/lib/sync-box/types';
import { getNodeUserSyncBox } from '../sync-boxes/nodeUser';
// Convert node user data to user data format
function convertNodeUserToUserData(nodeUserData = {}) {
    return Object.fromEntries(Object.entries(nodeUserData).map(([key, value]) => [key, value.value]));
}
const NodeUserInfoAPIs = {
    /**
     * Get user data for a single question
     */
    async getUserData(userID, questionID) {
        const nodeUserData = await db.qnaNodeUser
            .where('entityRef')
            .equals(questionID)
            .and(node => node.userID === userID)
            .first();
        return convertNodeUserToUserData(nodeUserData?.data);
    },
    /**
     * Update user data for a question
     */
    async updateUserData(userID, questionID, key, value) {
        const existingData = await db.qnaNodeUser
            .where('entityRef')
            .equals(questionID)
            .and(node => node.userID === userID)
            .first();
        const updatedData = {
            ...(existingData?.data ?? {}),
            [key]: {
                ts: new Date(),
                value,
            },
        };
        if (existingData) {
            // Update existing record
            await db.qnaNodeUser.update(existingData._id, {
                data: updatedData,
                utime: new Date(),
            });
        }
        else {
            // Create new record
            await db.qnaNodeUser.add({
                _id: `${userID}_${questionID}`,
                _status: SyncStatus.PENDING_PUSH,
                _syncBoxId: (await getNodeUserSyncBox().getConfig()).syncBoxId,
                userID,
                entityRef: questionID,
                data: updatedData,
                ctime: new Date(),
                utime: new Date(),
            });
        }
    },
    /**
     * Get analytics data for questions (read/bookmarked counts)
     */
    async getAnalytics(userID, questionIDs) {
        const nodeUserDataList = await db.qnaNodeUser
            .where('entityRef')
            .anyOf(questionIDs)
            .and(node => node.userID === userID)
            .toArray();
        const analytics = {
            readCount: 0,
            bookmarkedCount: 0,
            totalQuestions: questionIDs.length,
        };
        nodeUserDataList.forEach(item => {
            if (item.data.read?.value)
                analytics.readCount++;
            if (item.data.bookmarked?.value)
                analytics.bookmarkedCount++;
        });
        return analytics;
    },
    /**
     * Get all user data for a specific user
     */
    async getAllUserData(userID) {
        const nodeUserDataList = await db.qnaNodeUser
            .where('userID')
            .equals(userID)
            .toArray();
        return nodeUserDataList.map(item => ({
            questionID: item.entityRef,
            userData: convertNodeUserToUserData(item.data),
        }));
    },
    /**
     * Delete user data for a question
     */
    async deleteUserData(userID, questionID) {
        const existingData = await db.qnaNodeUser
            .where('entityRef')
            .equals(questionID)
            .and(node => node.userID === userID)
            .first();
        if (existingData) {
            await db.qnaNodeUser.delete(existingData._id);
        }
    },
};
export default NodeUserInfoAPIs;
